<template>
  <div>
    <div
      class="modal fade menu-visibility-modal"
      id="menuVisibilityModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="menuVisibilityModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
      ref="menuVisibilityModal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content mv-modal-content">
          <!-- Header -->
          <div class="mv-header">
            <div class="mv-header-icon">
              <i class="material-icons">tune</i>
            </div>
            <div class="mv-header-text">
              <h5 id="menuVisibilityModalLabel">Options Display</h5>
              <p>Show or hide sidebar modules for this clinic</p>
            </div>
            <button type="button" class="close d-close" @click="closeModal" data-dismiss="modal">
              <i class="material-icons">close</i>
            </button>
          </div>

          <!-- Body -->
          <div class="mv-body">
            <div class="mv-section-label">PORTAL MODULES</div>

            <div class="mv-toggle-list">
              <!-- Surveys -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon survey-icon"></span>
                  <div>
                    <div class="mv-name">Surveys</div>
                    <div class="mv-desc">Survey results, individual &amp; analytics findings</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input
                    type="checkbox"
                    v-model="settings.surveys"
                    @change="onToggle('surveys')"
                    :disabled="saving"
                  />
                  <span class="mv-slider"></span>
                </label>
              </div>

              <!-- Wallet -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon wallet-icon"></span>
                  <div>
                    <div class="mv-name">Wallet</div>
                    <div class="mv-desc">Recharge wallet, balance &amp; transaction history</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input
                    type="checkbox"
                    v-model="settings.wallets"
                    @change="onToggle('wallets')"
                    :disabled="saving"
                  />
                  <span class="mv-slider"></span>
                </label>
              </div>

              <!-- Package Management -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon package-icon"></span>
                  <div>
                    <div class="mv-name">Package Management</div>
                    <div class="mv-desc">List, manage &amp; purchase packages, package reports</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input
                    type="checkbox"
                    v-model="settings.package_management"
                    @change="onToggle('package_management')"
                    :disabled="saving"
                  />
                  <span class="mv-slider"></span>
                </label>
              </div>

              <!-- Referrals -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon referrals-icon"></span>
                  <div>
                    <div class="mv-name">Referrals</div>
                    <div class="mv-desc">Referred patients list and referral history</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input
                    type="checkbox"
                    v-model="settings.referrals"
                    @change="onToggle('referrals')"
                    :disabled="saving"
                  />
                  <span class="mv-slider"></span>
                </label>
              </div>
              <!-- Diet & Nutrition -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon nutrition-icon"></span>
                  <div>
                    <div class="mv-name">Diet & Nutrition</div>
                    <div class="mv-desc">Diet plans, nutrition tracking and dietary consultations</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input type="checkbox" v-model="settings.dietarymodule" @change="onToggle('dietarymodule')"
                    :disabled="saving" />
                  <span class="mv-slider"></span>
                </label>
              </div>

              <!-- Roster Management -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon roster-icon"></span>
                  <div>
                    <div class="mv-name">Roster Management</div>
                    <div class="mv-desc">Manage staff schedules, shifts and roster assignments</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input type="checkbox" v-model="settings.roster" @change="onToggle('roster')"
                    :disabled="saving" />
                  <span class="mv-slider"></span>
                </label>
              </div>
              <!-- Radiology Portal -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon radiology-icon"></span>
                  <div>
                    <div class="mv-name">Radiology Portal</div>
                    <div class="mv-desc">Radiology lab queue and imaging reports</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input
                    type="checkbox"
                    v-model="settings.radiology"
                    @change="onToggle('radiology')"
                    :disabled="saving"
                  />
                  <span class="mv-slider"></span>
                </label>
              </div>

              <!-- Pathology Portal -->
              <div class="mv-toggle-row" :class="{ 'mv-disabled': saving }">
                <div class="mv-toggle-info">
                  <span class="mv-icon pathology-icon"></span>
                  <div>
                    <div class="mv-name">Pathology Portal</div>
                    <div class="mv-desc">Pathology lab queue and diagnostic reports</div>
                  </div>
                </div>
                <label class="mv-switch">
                  <input
                    type="checkbox"
                    v-model="settings.pathology"
                    @change="onToggle('pathology')"
                    :disabled="saving"
                  />
                  <span class="mv-slider"></span>
                </label>
              </div>
            </div>

            <!-- Save feedback -->
            <transition name="mv-fade">
              <div v-if="saveMessage" class="mv-save-feedback" :class="saveMessageType">
                <i class="material-icons">{{ saveMessageType === 'success' ? 'check_circle' : 'error' }}</i>
                {{ saveMessage }}
              </div>
            </transition>
          </div>

          <!-- Footer -->
          <div class="mv-footer">
            <span class="mv-footer-note">
              <i class="material-icons">info</i>
              Changes apply immediately for all users on reload
            </span>
            <div class="mv-footer-actions">
              <!-- <button class="mv-btn-cancel" @click="closeModal" :disabled="saving">
                Close
              </button> -->
              <button class="mv-btn-save primary-btn ripple" @click="saveSettings" :disabled="saving">
                <span v-if="saving">
                  <i class="material-icons mv-spin">autorenew</i> Saving…
                </span>
                <span v-else>Save Changes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import rest_service from "../../api/rest_service";

export default {
  name: "MenuVisibilitySettings",
  props: {
    showmodal: {
      type: Boolean,
      default: false,
    },
    parentprop: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      settings: {
        surveys: false,
        wallets: false,
        package_management: false,
        referrals: false,
        dietarymodule: false,
        roster: false,
        radiology: false,
        pathology: false,
      },
      // snapshot of last-saved state so Cancel can revert
      savedSettings: {},
      saving: false,
      saveMessage: "",
      saveMessageType: "success",
      _saveMessageTimer: null,
    };
  },
  watch: {
    showmodal(val) {
      if (val) {
        this.loadFromStorage();
        this.$nextTick(() => {
          $(this.$refs.menuVisibilityModal).modal("show");
        });
      } else {
        $(this.$refs.menuVisibilityModal).modal("hide");
      }
    },
  },
  mounted() {
    const self = this;
    $(this.$refs.menuVisibilityModal).on("hidden.bs.modal", function () {
      if (self.parentprop) {
        // Mirror the pattern used by every other popup in this codebase:
        // reset the controlling flag on the parent so re-opening works correctly.
        self.parentprop.opencloseMenuVisibilityModal = false;
      }
      self.$emit("close");
    });
  },
  beforeDestroy() {
    clearTimeout(this._saveMessageTimer);
    $(this.$refs.menuVisibilityModal).modal("hide");
  },
  methods: {
    // ─── Read current state from localStorage ──────────────────────────────
    loadFromStorage() {
      const raw = window.localStorage.getItem("tenantbusinesssetup");
      if (!raw) return;
      try {
        const setup = JSON.parse(raw);
        this.settings = {
          surveys:            !!setup.surveys,           // not a real key yet – see note below
          wallets:            !!setup.wallets,
          package_management: !!setup.package_management,
          referrals:          setup.referrals !== undefined ? !!setup.referrals : true,
          dietarymodule:      !!setup.dietarymodule,
          roster:             !!setup.roster,
          radiology:          !!setup.radiology,
          pathology:          !!setup.pathology,
        };
        // deep-copy as saved baseline
        this.savedSettings = { ...this.settings };
      } catch (e) {
        console.error("MenuVisibilitySettings: failed to parse tenantbusinesssetup", e);
      }
    },

    // ─── Called on every individual toggle (optional immediate UX feedback) ─
    onToggle(key) {
      // No-op for now – all saves are deferred to Save Changes.
      // Extend here if you want auto-save behaviour per toggle.
    },

    // ─── Persist to localStorage + (optionally) your API ───────────────────
    saveSettings() {
      this.saving = true;
      this.saveMessage = "";

      try {
        const raw = window.localStorage.getItem("tenantbusinesssetup");
        const setup = raw ? JSON.parse(raw) : {};

        // Merge only the keys we own
        const updated = {
          ...setup,
          surveys: this.settings.surveys,
          wallets: this.settings.wallets,
          package_management: this.settings.package_management,
          referrals: this.settings.referrals,
          dietarymodule: this.settings.dietarymodule,
          roster: this.settings.roster,
          radiology: this.settings.radiology,
          pathology: this.settings.pathology,
        };

        window.localStorage.setItem("tenantbusinesssetup", JSON.stringify(updated));

        // ── Propagate to the sidebar component synchronously ────────────────
        if (this.parentprop) {
          this.parentprop.iswallet = this.settings.wallets;
          this.parentprop.ispack = this.settings.package_management;
          this.parentprop.isRadiology = this.settings.radiology;
          this.parentprop.isPathology = this.settings.pathology;
          // referrals: controlled by isprovider && !IsVS in the template,
          // so we store the flag and the router-link will respect it on next render.
          // surveys: visible when isAdmin – toggling hides the <li v-if="isAdmin"> group.
          // We add dedicated flags for both so the sidebar can read them:
          this.parentprop.isReferralsEnabled = this.settings.referrals;
          this.parentprop.isSurveysEnabled = this.settings.surveys;
          this.parentprop.isRosterEnabled = this.settings.roster;
          this.parentprop.isDietNutritionEnabled = this.settings.dietarymodule;
        }

        this.savedSettings = { ...this.settings };
        this.showFeedback("Settings saved successfully", "success");
        this.persistToAPI(updated);


      } catch (e) {
        console.error("MenuVisibilitySettings: save failed", e);
        this.showFeedback("Save failed. Please try again.", "error");
      } finally {
        this.saving = false;
        setTimeout(
          function () {
            $(this.$refs.menuVisibilityModal).modal("hide");
          }.bind(this),
          3000
        );
        
      }
    },

    // ─── Optional API call – wire up when the endpoint is ready ────────────
    persistToAPI(payload) {
      const provider  = JSON.parse(localStorage.getItem("loggedInUserInfo") || "{}");
      const token     = localStorage.getItem("accesstoken") || "";
      const headers   = {
        x_tenant_id:              provider.tenant_id,
        role_unique_id:           provider.role.unique_id,
        loggedin_user_unique_id:  provider.unique_id,
        Authorization:            token,
      };
      return Axios.post(
        `${rest_service.baseURL}/staff/updatemenuvisibility`,
        payload,
        { headers }
      ).catch(err => console.warn("MenuVisibilitySettings: API persist failed", err));
    },

    // ─── Transient feedback banner ──────────────────────────────────────────
    showFeedback(msg, type = "success") {
      clearTimeout(this._saveMessageTimer);
      this.saveMessage     = msg;
      this.saveMessageType = type;
      this._saveMessageTimer = setTimeout(() => { this.saveMessage = ""; }, 3500);
    },

    closeModal() {
      // Revert uncommitted toggle changes
      this.settings = { ...this.savedSettings };
      $(this.$refs.menuVisibilityModal).modal("hide");
    },
  },
};
</script>

<style scoped>
@keyframes mv-spin {
  to { transform: rotate(360deg); }
}
/* ── Modal shell ─────────────────────────────────────────────────────────── */
.mv-modal-content {
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  font-family: inherit;
  min-width: 460px;
}

/* ── Header ──────────────────────────────────────────────────────────────── */
.mv-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px 16px;
  /* background: #1565c0;         */
  color: #000;
}

.mv-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mv-header-icon .material-icons {
  font-size: 22px;
}

.mv-header-text {
  flex: 1;
}

.mv-header-text h5 {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.mv-header-text p {
  margin: 0;
  font-size: 12px;
  color: #000;
}

.mv-close-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: background 0.15s;
}

.mv-close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

/* ── Body ────────────────────────────────────────────────────────────────── */
.mv-body {
  padding: 20px 24px 12px;
  background: #f8f9fb;
}

.mv-section-label {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #90a4ae;
  margin-bottom: 12px;
}

/* ── Toggle rows ─────────────────────────────────────────────────────────── */
.mv-toggle-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mv-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  padding: 12px 16px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.mv-toggle-row:hover {
  border-color: #90caf9;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.07);
}

.mv-toggle-row.mv-disabled {
  opacity: 0.55;
  pointer-events: none;
}

.mv-toggle-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mv-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: inline-block;
  flex-shrink: 0;
  background-color: #e3f0fd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 18px 18px;
}

/* Reuse existing sprite classes from the app; fall back to a colored square */
.mv-icon.survey-icon    { background-color: #e8f5e9; }
.mv-icon.wallet-icon    { background-color: #fff3e0; }
.mv-icon.package-icon   { background-color: #f3e5f5; }
.mv-icon.referrals-icon { background-color: #e1f5fe; }
.mv-icon.radiology-icon { background-color: #fce4ec; }
.mv-icon.pathology-icon { background-color: #e8f5e9; }

.mv-name {
  font-size: 14px;
  font-weight: 600;
  color: #263238;
  line-height: 1.3;
}

.mv-desc {
  font-size: 11.5px;
  color: #78909c;
  margin-top: 1px;
}

/* ── iOS-style toggle switch ─────────────────────────────────────────────── */
.mv-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin: 0;
  flex-shrink: 0;
}

.mv-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.mv-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #cfd8dc;
  border-radius: 24px;
  transition: background 0.2s;
}

.mv-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.18);
}

.mv-switch input:checked + .mv-slider {
  background: #1565c0;
}

.mv-switch input:checked + .mv-slider::before {
  transform: translateX(20px);
}

/* ── Save feedback banner ─────────────────────────────────────────────────── */
.mv-save-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  margin-top: 14px;
}

.mv-save-feedback.success {
  background: #e8f5e9;
  color: #2e7d32;
}

.mv-save-feedback.error {
  background: #ffebee;
  color: #c62828;
}

.mv-save-feedback .material-icons {
  font-size: 17px;
}

/* ── Footer ──────────────────────────────────────────────────────────────── */
.mv-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px 18px;
  background: #fff;
  border-top: 1px solid #e8ecf0;
  gap: 12px;
}

.mv-footer-note {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  color: #90a4ae;
}

.mv-footer-note .material-icons {
  font-size: 15px;
}

.mv-footer-actions {
  display: flex;
  gap: 10px;
}

.mv-btn-cancel,
/* .mv-btn-save {
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.15s, opacity 0.15s;
  display: flex;
  align-items: center;
  gap: 6px;
} */

.mv-btn-cancel {
  background: #eceff1;
  color: #546e7a;
}

.mv-btn-cancel:hover:not(:disabled) {
  background: #cfd8dc;
}

.mv-btn-save {
  /* background: #1565c0;
  color: #fff; */
  min-width: 140px;
}

/* .mv-btn-save:hover:not(:disabled) {
  background: #0d47a1;
} */

.mv-btn-cancel:disabled,
/* .mv-btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
} */

/* ── Spinner ─────────────────────────────────────────────────────────────── */


.mv-spin {
  font-size: 16px;
  animation: mv-spin 0.8s linear infinite;
}

/* ── Transition ──────────────────────────────────────────────────────────── */
.mv-fade-enter-active,
.mv-fade-leave-active {
  transition: opacity 0.25s;
}
.mv-fade-enter,
.mv-fade-leave-to {
  opacity: 0;
}
.modal-dialog.modal-dialog-centered{
  margin-top: 25px;
}
.modal-dialog .modal-content{
  padding-top: 0;
}
</style>